import gql from 'graphql-tag';

export const PAGE_NUMBER = 1;
export const PAGE_SIZE = 50;
export const SORT_PARAM = 'PRICE_ASC';

const validateFieldForNull = (field) => (typeof field === 'undefined' ? null : field);
const validateFieldForZero = (field) => (typeof field === 'undefined' ? 0 : field);

export const setBaseVariables = (systemId, propertyId) => {
    return {
        request: {
            propertyId,
            systemId,
            paging: {page: PAGE_NUMBER, pageSize: PAGE_SIZE},
            sort: SORT_PARAM
        }
    };
};

export const setVariables = (inputParams, systemId, propertyId) => {
    const {
        arrival,
        departure,
        filter,
        adultsCount,
        childrenCount,
        petIncluded,
        minBedrooms,
        maxBedrooms,
        minSleeps,
        maxSleeps,
        minBathrooms,
        maxBathrooms,
        minPrice,
        maxPrice
    } = inputParams;

    return {
        request: {
            propertyId,
            systemId,
            paging: {page: PAGE_NUMBER, pageSize: PAGE_SIZE},
            sort: SORT_PARAM,
            dates:
                arrival && departure
                    ? {
                          arrivalDate: arrival,
                          departureDate: departure
                      }
                    : null,
            filters: filter,
            coreFilters: {
                adults: validateFieldForNull(adultsCount),
                children: validateFieldForNull(childrenCount),
                pets: petIncluded ? 1 : 0,
                minBedrooms: validateFieldForZero(minBedrooms),
                maxBedrooms: validateFieldForNull(maxBedrooms),
                minSleeps: validateFieldForZero(minSleeps),
                maxSleeps: validateFieldForNull(maxSleeps),
                minBathrooms: validateFieldForZero(minBathrooms),
                maxBathrooms: validateFieldForNull(maxBathrooms),
                minPrice: minPrice === 0 ? null : validateFieldForNull(minPrice),
                maxPrice: validateFieldForNull(maxPrice)
            }
        }
    };
};

export const createMultiUnitSearchQuery = (currency) => {
    return gql`
        query multiUnitSearch($request: MultiUnitSearchRequest!) {
            multiUnitSearch(request: $request) {
                resultCount
                listings {
                    petsAllowed
                    instantBookable
                    mobileThumbnailUrl
                    bedrooms
                    unitMetadata {
                        unitName
                    }
                    sleeps
                    propertyMetadata {
                        headline
                    }
                    propertyType
                    bathrooms {
                        full
                        half
                        toiletOnly
                    }
                    spaces {
                        bedrooms {
                            capacity
                            name
                            note
                            type
                        }
                        spacesSummary {
                            area {
                                areaValue
                            }
                        }
                    }
                    averageRating
                    reviewCount
                    detailPageUrl
                    priceSummary(currency: "${currency}") {
                        amount
                        pricePeriodDescription
                        formattedAmount
                        edapEventJson
                    }
                    listingId
                }
            }
        }
    `;
};
